module.exports = __webpack_public_path__ + "img/conecta_suite_full.4fd54047.png";